import { render, staticRenderFns } from "./BandaMultiplicadora.vue?vue&type=template&id=31c02058&scoped=true"
import script from "./BandaMultiplicadora.vue?vue&type=script&lang=js"
export * from "./BandaMultiplicadora.vue?vue&type=script&lang=js"
import style0 from "./BandaMultiplicadora.vue?vue&type=style&index=0&id=31c02058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c02058",
  null
  
)

export default component.exports